import React from "react"
import HelperMore from "./_helperMore"
import { FlowGetfocusToSelect } from "src/helpers/Flows/TableCell"
const BaseText = props => {
  const more = HelperMore.getMoreFromProps(props) || {}
  return (
    <textarea
      spellCheck="false"
      // value={props.value}
      {...HelperMore.getPropsValues(props, { defaultValueWhenNull: "" })}
      onChange={ev => {
        props.onChange && props.onChange(ev.currentTarget.value)
      }}
      onBlur={ev => {
        props.onBlur && props.onBlur(ev.currentTarget.value)
      }}
      onFocus={ev => {
        if (FlowGetfocusToSelect({ more })) {
          // console.log("focustToSelect")
          if (ev && ev.target && ev.target.select) {
            ev.target.select()
          }
        }
      }}
      className={props.className}
      style={props.style}
      {...props.attrs}
    />
  )
}

export default BaseText
